import React from "react";
import TextField from "@mui/material/TextField";

interface NumericInputProps {
  value: number | null;
  index: number;
  width?: number;
  verticalAlign?: string;
  handleQuantityChange: (newValue: number, index: number) => void;
}

const NumericInput: React.FC<NumericInputProps> = ({ value, index, width, verticalAlign, handleQuantityChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value);
    if (!isNaN(newValue)) {
      handleQuantityChange(newValue, index);
    }
  };

  return (
    <TextField
      variant="outlined"
      value={value?.toString() ?? ""}
      onChange={handleChange}
      fullWidth = {width ? false : true}
      style={{width: width}}
      inputProps={{
        inputMode: "numeric",
        pattern: "-?\\d*", // Pattern for numeric input
        style: {
          height: "10px",
        },
      }}
      sx={{
        width: "200px", // Increase width
        verticalAlign: verticalAlign ?? 'top',
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "lightgrey", // Light grey border
          },
          "&:hover fieldset": {
            borderColor: "var(--goa-color-interactive-hover)",
            boxShadow:
              "0 0 0 var(--goa-border-width-m) var(--goa-color-interactive-hover)",
          },
          "&.Mui-focused fieldset": {
            borderColor: "var(--goa-color-interactive-hover)",
            boxShadow:
              "0 0 0 var(--goa-border-width-m) var(--goa-color-interactive-focus)",
          },
        },
      }}
    />
  );
};

export default NumericInput;
